export function getFirstPageAdpParam(page: number, adp?: string): { adp?: string } {
  if (page !== 1 || adp === undefined) {
    return {};
  }

  return { adp };
}
